import { ReportTableColumn } from "../models/report-table";
export const Columns: { [field: string]: ReportTableColumn } = {

  item: { field: 'item', header: 'Ítem', type: 'text', width: '90px' },
  itemResumen: { field: 'itemResumen', header: 'Ítem', type: 'text', width: '90px' }, // para el conteo especial de reportes por nivel
  fechaYHora: { field: 'fechaYHora', header: 'Fecha / Hora', type: 'date', width: '150px' },
  fecha: { field: 'fecha', header: 'Fecha', type: 'date', width: '110px' },
  hora: { field: 'hora', header: 'Hora', type: 'date', width: '110px' },

  fechaYHoraEvento: { field: 'fechaYHoraEvento', header: 'Fecha / Hora del Evento', type: 'date', width: '150px' },
  fechaEvento: { field: 'fechaEvento', header: 'Fecha del Evento', type: 'date', width: '160px' },
  horaEvento: { field: 'horaEvento', header: 'Hora del Evento', type: 'date', width: '160px' },


  fechaYHoraEnrolado: { field: 'fechaYHoraEnrolado', header: 'Fecha / Hora del Evento', type: 'date', width: '150px' },
  fechaEnrolado: { field: 'fechaEnrolado', header: 'Fecha Enrolado', type: 'date', width: '160px' },
  horaEnrolado: { field: 'horaEnrolado', header: 'Hora Enrolado', type: 'date', width: '160px' },

  fechaYHoraServidor: { field: 'fechaYHoraServidor', header: 'Fecha / Hora del Servidor', type: 'date', width: '150px' },
  fechaServidor: { field: 'fechaServidor', header: 'Fecha del Servidor', type: 'date', width: '160px' },
  horaServidor: { field: 'horaServidor', header: 'Hora del Servidor', type: 'date', width: '160px' },

  fechaYHoraServidorInicio: { field: 'fechaYHoraServidorInicio', header: 'Fecha / Hora de Inicio del Servidor', type: 'date', width: '200px' },
  fechaServidorInicio: { field: 'fechaServidorInicio', header: 'Fecha de Inicio del Servidor', type: 'date', width: '180px' },
  horaServidorInicio: { field: 'horaServidorInicio', header: 'Hora de Inicio del Servidor', type: 'date', width: '180px' },

  fechaYHoraServidorFin: { field: 'fechaYHoraServidorFin', header: 'Fecha / Hora de Fin del Servidor', type: 'date', width: '200px' },
  fechaServidorFin: { field: 'fechaServidorFin', header: 'Fecha de Fin del Servidor', type: 'date', width: '180px' },
  horaServidorFin: { field: 'horaServidorFin', header: 'Hora de Fin del Servidor', type: 'date', width: '180px' },

  fechaYHoraInicio: { field: 'fechaYHoraInicio', header: 'Fecha / Hora de Inicio', type: 'date', width: '160px' },
  fechaInicio: { field: 'fechaInicio', header: 'Fecha de Inicio', type: 'date', width: '160px' },
  horaInicio: { field: 'horaInicio', header: 'Hora de Inicio', type: 'date', width: '160px' },

  fechaYHoraEntrada: { field: 'fechaYHoraEntrada', header: 'Fecha / Hora de Entrada', type: 'date', width: '200px' },
  fechaYHoraSalida: { field: 'fechaYHoraSalida', header: 'Fecha / Hora de Salida', type: 'date', width: '200px' },
  fechaYHoraFin: { field: 'fechaYHoraFin', header: 'Fecha / Hora de Fin', type: 'date', width: '160px' },
  fechaFin: { field: 'fechaFin', header: 'Fecha de Fin', type: 'date', width: '160px' },
  horaFin: { field: 'horaFin', header: 'Hora de Fin', type: 'date', width: '160px' },
  motivo: { field: 'motivo', header: 'Motivo', type: 'text', width: '160px' },

  fechaYHoraFinGps: { field: 'fechaYHoraFinGps', header: 'Fecha / Hora de Fin GPS', type: 'date', width: '160px' },
  fechaFinGps: { field: 'fechaFinGps', header: 'Fecha de Fin GPS', type: 'date', width: '160px' },
  horaFinGps: { field: 'horaFinGps', header: 'Hora de Fin GPS', type: 'date', width: '160px' },

  inicioExceso: { field: 'inicioExceso', header: 'Inicio del Exceso', type: 'date', width: '160px' },
  horaExceso: { field: 'horaExceso', header: 'Hora del Exceso', type: 'date', width: '160px' },
  finExceso: { field: 'finExceso', header: 'Fin del Exceso', type: 'date', width: '160px' },

  fechaYHoraInicioGps: { field: 'fechaYHoraInicioGps', header: 'Fecha / Hora de Inicio GPS', type: 'date', width: '160px' },
  fechaInicioGps: { field: 'fechaInicioGps', header: 'Fecha de Inicio GPS', type: 'date', width: '130px' },
  horaInicioGps: { field: 'horaInicioGps', header: 'Hora de Inicio GPS', type: 'date', width: '130px' },
  rendimientoPorGalon: { field: 'rendimientoPorGalon', header: 'Rendimiento por Galón (km/gal)', type: 'text', width: '180px' },
  tiempoMovimiento: { field: 'tiempoMovimiento', header: 'Tiempo en Movimiento', type: 'date', width: '180px' },
  tiempoRelenti: { field: 'tiempoRelenti', header: 'Tiempo Ralenti', type: 'date', width: '160px' },
  tiempoApagado: { field: 'tiempoApagado', header: 'Tiempo Apagado', type: 'date', width: '160px' },
  angulo: { field: 'angulo', header: 'Ángulo', type: 'text', width: '110px' },
  duracionParadas: { field: 'duracionParadas', header: 'Duración de Paradas', type: 'date', width: '170px' },
  contadorParadas: { field: 'contadorParadas', header: 'Contador de Paradas', type: 'text', width: '170px' },


  duracion: { field: 'duracion', header: 'Duración', type: 'date', width: '110px' },

  distanciaRecorrida: { field: 'distanciaRecorrida', header: 'Distancia Recorrida (km)', type: 'number', width: '140px' },
  velocidadMaxGps: { field: 'velocidadMaxGps', header: 'Vel Máx GPS (km/h)', type: 'number', width: '120px' },
  velocidadMaxCan: { field: 'velocidadMaxCan', header: 'Vel Máx CAN (km/h)', type: 'number', width: '120px' },

  fechaEvaluacion: { field: 'fechaEvaluacion', header: 'Fecha de Evaluación', type: 'date', width: '170px' },
  horaEvaluacion: { field: 'horaEvaluacion', header: 'Hora de Evaluación', type: 'date', width: '170px' },
  velocidad: { field: 'velocidad', header: 'Velocidad (km/h)', type: 'number', width: '170px' },
  velocidadMax: { field: 'velocidadMax', header: 'Vel Máx (km/h)', type: 'number', width: '150px' },
  velocidadMin: { field: 'velocidadMin', header: 'Vel Mín (km/h)', type: 'number', width: '150px' },
  idConductor: { field: 'idConductor', header: 'ID Conductor', type: 'text', width: '150px' },
  criterioEvaluacion: { field: 'criterioEvaluacion', header: 'Criterio de Evaluación', type: 'text', width: '210px' },
  newDriver: { field: 'newDriver', header: 'Nuevo Conductor', type: 'text', width: '290px' },
  observacion: { field: 'observacion', header: 'Observación', type: 'text', width: '200px' },
  operadorMonitoreo: { field: 'operadorMonitoreo', header: 'Operador de Monitoreo', type: 'text', width: '280px' },
  comunicacionRadial: { field: 'comunicacionRadial', header: 'Comunicación Radial', type: 'text', width: '170px' },
  estadoDuot2: { field: 'estadoDuot2', header: 'Estado DUOT2', type: 'text', width: '150px' },
  velocidad360: { field: 'velocidad360', header: 'Vel 360 (km/h)', type: 'number', width: '150px' },
  odometroVirtual: { field: 'odometroVirtual', header: 'Odómetro Virtual', type: 'text', width: '150px' },
  canRpm: { field: 'canRpm', header: 'CAN RPM', type: 'text', width: '110px' },
  rpm: { field: 'rpm', header: 'RPM', type: 'text', width: '100px' },


  rpmAlta: { field: 'rpmAlta', header: 'RPM Alta', type: 'text', width: '150px' },
  rpmECO: { field: 'rpmECO', header: 'RPM ECO', type: 'text', width: '150px' },
  altitud: { field: 'altitud', header: 'Altitud', type: 'text', width: '110px' },
  alimentacionGPS: { field: 'alimentacionGPS', header: 'Alimentación GPS', type: 'text', width: '150px' },
  satelite: { field: 'satelite', header: 'Satélite', type: 'text', width: '150px' },
  ignicion: { field: 'ignicion', header: 'Ignición', type: 'text', width: '150px' },
  contactoMotor: { field: 'contactoMotor', header: 'Contacto de Motor', type: 'text', width: '120px' },
  alcoholemia: { field: 'alcoholemia', header: 'Alcoholemia', type: 'text', width: '150px' },
  reconocimientoFacial: { field: 'reconocimientoFacial', header: 'Reconocimiento Facial', type: 'text', width: '150px' },
  fechaEntrada: { field: 'fechaEntrada', header: 'Fecha de Entrada', type: 'date', width: '150px' },
  horaEntrada: { field: 'horaEntrada', header: 'Hora de Entrada', type: 'date', width: '150px' },
  fechaSalida: { field: 'fechaSalida', header: 'Fecha de Salida', type: 'date', width: '150px' },
  horaSalida: { field: 'horaSalida', header: 'Hora de Salida', type: 'date', width: '150px' },
  cantTramas: { field: 'cantTramas', header: 'Cant. de Tramas', type: 'text', width: '150px' },
  tramas: { field: 'tramas', header: 'Tramas', type: 'text', width: '110px' },
  zonaCercana: { field: 'zonaCercana', header: 'Zona Cercana', type: 'text', width: '150px' },
  zona: { field: 'zona', header: 'Zona', type: 'text', width: '150px' },
  zonaGeocerca: { field: 'zonaGeocerca', header: 'Zona Geocerca', type: 'text', width: '210px' },

  leve: { field: 'leve', header: 'Leve(1,2)', type: 'number', width: '150px' },
  grave: { field: 'grave', header: 'Grave(3,5)', type: 'number', width: '150px' },
  muyGrave: { field: 'muyGrave', header: 'Muy Grave(>=6)', type: 'number', width: '150px' },

  nivel1: { field: 'leve', header: 'Nivel I', type: 'number', width: '150px' },
  nivel2: { field: 'grave', header: 'Nivel II', type: 'number', width: '150px' },
  nivel3: { field: 'muyGrave', header: 'Nivel III', type: 'number', width: '150px' },

  direccionGeocerca: { field: 'direccionGeocerca', header: 'Dirección de Geocerca', type: 'text', width: '150px' },

  posicionGeocerca: { field: 'posicionGeocerca', header: 'Posición en Geocerca', type: 'text', width: '150px' },
  nivelCombustible: { field: 'nivelCombustible', header: 'Combustible (%)', type: 'text', width: '150px' },
  consumoCombustible: { field: 'consumoCombustible', header: 'Consumo (gal)', type: 'text', width: '150px' },
  consumoHrfc: { field: 'consumoHrfc', header: 'Consumo HRFC (gal)', type: 'text', width: '110px' },
  combustibleRestante: { field: 'combustibleRestante', header: 'Restante (gal)', type: 'text', width: '110px' },
  fatiga: { field: 'fatiga', header: 'Fatiga', type: 'text', width: '150px' },
  frenadaBrusca: { field: 'frenadaBrusca', header: 'Frenada Brusca', type: 'text', width: '150px' },
  aceleracionBrusca: { field: 'aceleracionBrusca', header: 'Aceleración Brusca', type: 'text', width: '150px' },
  voltageLevel: { field: 'voltageLevel', header: 'Nivel de Voltaje', type: 'text', width: '120px' },
  numeroGeo: { field: 'numeroGeo', header: 'N° Geo', type: 'text', width: '150px' },
  excesoVelocidad: { field: 'excesoVelocidad', header: 'Exceso Vel (km/h)', type: 'number', width: '100px' },
  zonaColor: { field: 'zonaColor', header: 'Zona Color', type: 'text', width: '150px' },
  velocidadMuyGrave: { field: 'velocidadMuyGrave', header: 'Vel Muy Grave (km/h)', type: 'number', width: '110px' },
  velocidadGrave: { field: 'velocidadGrave', header: 'Vel Grave (km/h)', type: 'number', width: '150px' },
  velocidadTolerancia: { field: 'velocidadTolerancia', header: 'Vel Leve (km/h)', type: 'number', width: '140px' },
  // maximaVelocidad:      { field: 'maximaVelocidad',      header: 'Máxima Velocidad', type: 'text', width: '180px' },

  nombre: { field: 'nombre', header: 'Nombre', type: 'text', width: '150px' },
  nombreEvento: { field: 'nombreEvento', header: 'Nombre del Evento', type: 'text', width: '220px' },
  descripcion: { field: 'descripcion', header: 'Descripción', type: 'text', width: '250px' },
  estado: { field: 'estado', header: 'Estado', type: 'text', width: '130px' },

  vehiculo: { field: 'vehiculo', header: 'Vehículo', type: 'text', width: '110px' },
  codigo: { field: 'codigo', header: 'Código', type: 'text', width: '100px' },
  placa: { field: 'placa', header: 'Placa', type: 'text', width: '100px' },
  tipoUnidad: { field: 'tipoUnidad', header: 'Tipo de Unidad', type: 'text', width: '180px' },
  unidad: { field: 'unidad', header: 'Unidad', type: 'text', width: '100px' },
  conductor: { field: 'conductor', header: 'Conductor', type: 'text', width: '200px' },

  velocidadPromedio: { field: 'velocidadPromedio', header: 'Vel Prom (km/h)', type: 'number', width: '150px' },
  velocidadPromedioGps: { field: 'velocidadPromedio', header: 'Vel Prom GPS (km/h)', type: 'number', width: '120px' },
  velocidadPromedioCan: { field: 'velocidadPromedioCan', header: 'Vel Prom CAN (km/h)', type: 'number', width: '120px' },

  velocidadMobileye: { field: 'velocidadMobileye', header: 'Vel Mobileye (km/h)', type: 'number', width: '170px' },
  velocidadGps: { field: 'velocidadGps', header: 'Vel GPS (km/h)', type: 'number', width: '160px' },
  velocidadGPSSpeed: { field: 'velocidadGPSSpeed', header: 'Vel GPS (Speed) (km/h)', type: 'number', width: '210px' },
  velocidadCan: { field: 'velocidadCan', header: 'Vel CAN (km/h)', type: 'number', width: '160px' },
  velocidadEco: { field: 'velocidadEco', header: 'Vel Eco (km/h)', type: 'number', width: '160px' },
  odometro: { field: 'odometro', header: 'Odómetro', type: 'text', width: '110px' },

  errorMobileye_ME427: { field: 'errorMobileye_ME427', header: 'Error de Mobileye', type: 'text', width: '170px' },

  odometroInicial: { field: 'odometroInicial', header: 'Odómetro Inicial', type: 'text', width: '160px' },
  odometroFinal: { field: 'odometroFinal', header: 'Odómetro Final', type: 'text', width: '160px' },

  odometroVirtualInicial: { field: 'odometroInicial', header: 'Odómetro Virtual Inicial', type: 'text', width: '160px' },
  odometroVirtualFinal: { field: 'odometroFinal', header: 'Odómetro Virtual Final', type: 'text', width: '160px' },


  limiteVelocidadZona: { field: 'limiteVelocidadZona', header: 'Límite Vel Zona (km/h)', type: 'number', width: '160px' },
  recorrido: { field: 'recorrido', header: 'Recorrido (km)', type: 'number', width: '240px' },

  nombreGeocerca: { field: 'nombreGeocerca', header: 'Geocerca', type: 'text', width: '210px' },
  puntoCercano: { field: 'puntoCercano', header: 'Punto Cercano', type: 'text', width: '200px' },
  ubicacion: { field: 'ubicacion', header: 'Ubicación', type: 'link', width: '200px' },
  latitud: { field: 'latitud', header: 'Latitud', type: 'text', width: '150px' },
  longitud: { field: 'longitud', header: 'Longitud', type: 'text', width: '150px' },
  referencia: { field: 'referencia', header: 'Referencia', type: 'text', width: '400px' },
  latitud2: { field: 'latitud2', header: 'Latitud 2', type: 'text', width: '150px' },
  longitud2: { field: 'longitud2', header: 'Longitud 2', type: 'text', width: '150px' },
  enlaceArchivo: { field: 'enlaceArchivo', header: 'Archivo', type: 'link', width: '150px' },
  enlaceImagen: { field: 'enlaceImagen', header: 'Imagen', type: 'link', width: '150px' },
  enlaceVideo: { field: 'enlaceVideo', header: 'Video', type: 'link', width: '150px' },
  parametros: { field: 'parametros', header: 'Parámetros', type: 'text', width: '800px' },

  tiempoDiferencia: { field: 'tiempoDiferencia', header: 'Tiempo Diferencia', type: 'text', width: '180px' },
  codigoConductor: { field: 'codigoConductor', header: 'Codigo Conductor', type: 'text', width: '200px' },
  dni: { field: 'dni', header: 'N° DNI', type: 'text', width: '200px' },
  codigoCipia: { field: 'codigoCipia', header: 'Codigo Cipia', type: 'text', width: '200px' },
  previsualizacion: { field: 'previsualizacion', header: 'Previsualización', type: 'img', width: '220px' },
  estadoGps: { field: 'estadoGps', header: 'Estado GPS', type: 'text', width: '130px' },
  fechaTracker: { field: 'fechaTracker', header: 'Última Hora de Transmisión', type: 'text', width: '220px' },
  estadoCipia: { field: 'estadoCipia', header: 'Estado Cipia', type: 'text', width: '220px' },
  estado360: { field: 'estado360', header: 'Fatiga 360', type: 'text', width: '220px' },
  caredrive: { field: 'caredrive', header: 'Caredrive', type: 'text', width: '220px' },
  can: { field: 'can', header: 'CAN', type: 'text', width: '120px' },
  adas: { field: 'adas', header: 'ADAS', type: 'text', width: '120px' },
  alcotester: { field: 'alcotester', header: 'Alcotester', type: 'text', width: '120px' },


  temperaturaMin: { field: 'temperaturaMin', header: 'Temp Min (°C)', type: 'text', width: '120px' },
  temperaturaMax: { field: 'temperaturaMax', header: 'Temp Max (°C)', type: 'text', width: '120px' },
  temperaturas: { field: 'temperaturas', header: 'Temperaturas (°C)', type: 'text', width: '130px' },

  humedadMin: { field: 'humedadMin', header: 'Humed Min (%)', type: 'text', width: '120px' },
  humedadMax: { field: 'humedadMax', header: 'Humed Max (%)', type: 'text', width: '120px' },
  humedades: { field: 'humedades', header: 'Humedades (%)', type: 'text', width: '130px' },

  temperaturaGps: { field: 'temperaturaGps', header: 'Temp GPS', type: 'text', width: '120px' },
  temperaturaEye: { field: 'temperaturaEye', header: 'Temp EYE', type: 'text', width: '120px' },
  temperaturaBle: { field: 'temperaturaBle', header: 'Temp BLE', type: 'text', width: '120px' },
  humedadEye: { field: 'humedadEye', header: 'Humedad EYE', type: 'text', width: '1450px' },
  humedadBle: { field: 'humedadBle', header: 'Humedad BLE', type: 'text', width: '145px' },
  nivelBateria: { field: 'nivelBateria', header: 'Niv Bateria', type: 'text', width: '130px' },
  nivelCobertura: { field: 'nivelCobertura', header: 'Niv Cobertura', type: 'text', width: '130px' },

  gerencia: { field: 'gerencia', header: 'Gerencia', type: 'text', width: '130px' },
  ruta: { field: 'ruta', header: 'Ruta', type: 'text', width: '130px' },
  falta: { field: 'falta', header: 'Falta', type: 'text', width: '130px' },

};
